import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './richTextEditor.css';
import { useEffect, useState } from 'react';

const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote'],
    ['link', 'image', 'video', 'formula'],

    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],

    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],

    ['clean']                                         // remove formatting button
];

const RichTextEditor = ({ label, value, placeholder, onChange, styles, required, defaultValue }) => {

    const [editorValue, setEditorValue] = useState(value || "");

    useEffect(() => {
        setEditorValue(value || "");
    }, [value]);

    const handleChange = (newValue) => {
        setEditorValue(newValue);
        onChange(newValue);
    };

    return (
        <div className="flex flex-col w-full text-base gap-1">
            <label className="gap-1 self-stretch text-gray-900 font-semibold">
                {required && <span className="text-red inline">* </span>}{label}
            </label>
            <div className=" bg-white rounded-md">
                <ReactQuill
                    modules={{
                        toolbar: toolbarOptions,
                    }}
                    theme="snow"
                    className={'quill'}
                    id={`rich-text-editor-${label}`}
                    defaultValue={defaultValue}
                    value={editorValue}
                    onChange={handleChange}
                    placeholder={placeholder}
                    style={{ flexGrow: 1, borderColor: 'rgba(236, 236, 238, 0.5)', borderRadius: '10px', ...styles }}
                />
            </div>
        </div>
    );
};

export default RichTextEditor;